import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from "../../services/user/user.service";
import { MerchantService } from "../../services/merchant/merchant.service";
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NeedAuthorize } from "../../classes/needAuthorize";
import { Global } from "../../classes/global";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-merchant-group-list',
  templateUrl: './merchant-group-list.component.html',
  styleUrls: ['./merchant-group-list.component.scss']
})
export class MerchantGroupListComponent extends NeedAuthorize {

  @ViewChild('groupModal') groupModal: ElementRef;

  merchantGroups: any[] = [];
  groupDetail: any = {
    id: '',
    name: '',
    orderSheetId: ''
  };
  isEdit = false;
  teamName: string = '';
  searchTerm: string = '';

  constructor(
    protected router: Router,
    protected userService: UserService,
    protected titleService: Title,
    private global: Global,
    private modalService: NgbModal,
    private merchantService: MerchantService,
    private toastr: ToastrService
  ) {
    super(router, userService, titleService);
    this.loadGroups();
  }

  loadGroups() {
    this.global.pageLoading = true;
    // List: only full-name groups (e.g. "Team X - Group Y"); placeholder teams are excluded
    this.merchantService.getFullMerchantGroups().subscribe(
      data => {
        this.merchantGroups = data || [];
        // Team Leader: derive team name from first full-name group prefix
        if (this.isTeamLeaderOnly && this.merchantGroups.length > 0) {
          const first = this.merchantGroups[0];
          const idx = first.name ? first.name.indexOf(' - ') : -1;
          this.teamName = idx >= 0 ? first.name.substring(0, idx).trim() : '';
        } else if (this.isTeamLeaderOnly) {
          this.merchantService.getTeamMerchantGroups().subscribe(
            teamData => {
              const list = teamData || [];
              const teamGroup = list.find((g: any) => g && g.name && g.name.indexOf(' - ') === -1);
              this.teamName = teamGroup ? teamGroup.name : '';
            }
          );
        }
        this.global.pageLoading = false;
      },
      () => {
        this.global.pageLoading = false;
      }
    );
  }

  openAddModal() {
    this.isEdit = false;
    this.groupDetail = { id: '', name: '', orderSheetId: '' };
    this.modalService.open(this.groupModal);
  }

  openEditModal(group: any) {
    this.isEdit = true;
    let name = group.name || '';
    if (this.isTeamLeaderOnly && this.teamName && name.startsWith(this.teamName + ' - ')) {
      name = name.substring((this.teamName + ' - ').length);
    }
    this.groupDetail = {
      id: group.id,
      name: name,
      orderSheetId: group.orderSheetId || ''
    };
    this.modalService.open(this.groupModal);
  }

  saveGroup() {
    if (!this.groupDetail.name || !this.groupDetail.name.trim()) {
      this.toastr.warning('Name is required.');
      return;
    }
    if (this.isEdit) {
      this.merchantService.saveAdminMerchantGroup(this.groupDetail).subscribe(
        () => {
          this.toastr.success('Merchant group updated.');
          this.modalService.dismissAll();
          this.loadGroups();
        },
        err => this.toastr.error(err?.error?.message || 'Update failed.')
      );
    } else {
      this.merchantService.createMerchantGroup(this.groupDetail).subscribe(
        () => {
          this.toastr.success('Merchant group created.');
          this.modalService.dismissAll();
          this.loadGroups();
        },
        err => this.toastr.error(err?.error?.message || 'Create failed.')
      );
    }
  }

  get filteredMerchantGroups(): any[] {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      return this.merchantGroups;
    }
    return this.merchantGroups.filter(g => {
      const name = (g && g.name) ? String(g.name).toLowerCase() : '';
      return name.indexOf(term) !== -1;
    });
  }

  get isTeamLeaderOnly(): boolean {
    const roles: string[] = this.userData?.roles || [];
    return roles.indexOf('Team Leader') > -1
      && roles.indexOf('Admin') === -1
      && roles.indexOf('SuperAdmin') === -1;
  }

  ngOnInit(): void {
  }
}
